<template>
  <y-shelf title="申请提现">
    <span slot="right"></span>
    <div slot="content">
      <div class="deposit-main">
         <el-form ref="form" :model="form"  label-width="100px">
           <el-form-item label="提现账号：">
             <el-select v-model="form.account" placeholder="请选择提现账号">
               <el-option label="支付宝" value="alipay"></el-option>
               <el-option label="建设银行" value="jianshe"></el-option>
               <el-option label="工商银行" value="gongshang"></el-option>
             </el-select>
           </el-form-item>
           <el-form-item label="提现金额：">
             <el-input
                  v-model="form.money"
                  type="text"
                  onkeyup="this.value=this.value.replace(/\D/g,'')"
                  onafterpaste="this.value=this.value.replace(/\D/g,'')"
                  clearable
                  style="width: 30%;"
              > <template slot="append">元</template></el-input>
              <span class="account_blance"><span>可提现余额：</span>  <b class="balance_money">0.00</b> <span>元</span> </span>
           </el-form-item>
           <el-form-item label="提现服务费：">
            <span>20 元</span> <span class="account_blance"><span>手续费：</span>  <b class="balance_money">5%</b></span>
           </el-form-item>
           <el-form-item label="实际到账：">
            <span class="c-span"><span class="c-text">20.00 </span>元</span>
           </el-form-item>
           <el-form-item>
             <el-button type="primary" @click="onSubmit">申请提现</el-button>
           </el-form-item>
         </el-form>
      </div>
    </div>
  </y-shelf>
</template>

<script>
  import YShelf from '/components/YShelf'
  export default {
    data() {
      return {
        form: {
          account: '',
          money: '',
        }
      }
    },
    methods: {
      onSubmit() {
        // console.log('submit!');
      }
    },
    components: {
      YShelf
    }
  }
</script>

<style lang="scss" scoped>
  .deposit-main {
    margin-top: 30px;
    margin-bottom: 100px;
    padding-left: 50px;
  }
  .account_blance {
    margin: 6px 0 0 10px;
    color: #999;
  }
  .balance_money {
    font-weight: normal;
    color: #f90;
  }
  .c-span {
    color: #333;
    font-size: 12px;
  }
  .c-text {
    color: #ff4e00;
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// withdraw.vue?3c053691